import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { UserContex } from '../context API/UserContext';

const UpdateContact = () => {
    const {id}=useParams()
    const [userData, setUserData] = useContext(UserContex);
    const navigate = useNavigate();
    const [address, setAddress] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState();
    const [telegram, setTelegram] = useState("");
    useEffect(() => {
      axios
        .get("https://back.waratechnology.com/api/contact/gtcontact/"+id)
        .then((res) => {
          setAddress(res.data.data.address);
          setEmail(res.data.data.email)
          setPhone(res.data.data.phone)
          setTelegram(res.data.data.telegram_contact)
        })
        .catch((err) => {
          console.log(err);
        });
    }, []);
     console.log(email);
         const handlesubmit = (e) => {
           e.preventDefault();
           axios
             .post("https://back.waratechnology.com/api/contact/updatecontact/"+id, {
               address,
               email,
               phone,
               telegram,
             })
             .then((res) => {
               console.log(res.data.msg);
               navigate("/contact");
             })
             .catch((err) => {
               console.log(err);
             });
         };
        
         useEffect(() => {
           if (!userData.user) {
             navigate("/login");
           }
         });
  return (
    <div className="bg-gray-400  flex justify-center items-center h-screen pt-12 ">
      <div className="w-3/4 h-3/4 md:w-1/2 md:h-3/4 bg-white  border border-black-1 border-rounded rounded-2xl p-4 shadow-lg shadow-white-500/50 ">
        <div className="flex justify-center mt-2 mb-4">
          <h1 className=" font-bold text-2xl">Update Contact</h1>
        </div>
        <form onSubmit={handlesubmit}>
          <div className="flex my-4">
            <label className="font-bold mr-2">Address</label>
            <input
              value={address}
              placeholder="address"
              type="text"
              className="w-full  pl-2 h-12 md:h-8 border border-gray-300 rounded-2xl"
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>
          <div className="flex my-4">
            <label className=" font-bold mr-2">Email</label>
            <input
              value={email}
              type="email"
              onChange={(e) => setEmail(e.target.value)}
              placeholder="email"
              className="w-full pl-2 border border-gray-300 rounded-2xl "
            />
          </div>
          <div className="flex my-4">
            <label className="font-bold mr-2">Phone</label>
            <input
              value={phone}
              placeholder="phone"
              type="number"
              className="w-full  pl-2 h-12 md:h-8 border border-gray-300 rounded-2xl"
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          <div className="flex my-4">
            <label className=" font-bold mr-2">Telegram</label>
            <input
              value={telegram}
              type="text"
              onChange={(e) => setTelegram(e.target.value)}
              placeholder="telegram"
              className="w-full pl-2 border border-gray-300 rounded-2xl "
            />
          </div>
          <div className="flex justify-center mt-4">
            <button
              type=""
              className="uppercase bg-red-500 mt-4 text-white px-4 py-1 rounded rounded-full"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UpdateContact
